import { ActionReducerMap } from '@ngrx/store';
import * as fromUser from './user';
import * as fromDevice from './device';

export interface State {
  device: fromDevice.DeviceState;
  user: fromUser.UserState;
}

export const reducers: ActionReducerMap<State> = {
  user: fromUser.reducer,
  device: fromDevice.reducer,
};

export const effects = [fromUser.UserEffects, fromDevice.DeviceEffects];
